import { render } from "./AlertExpiration.vue?vue&type=template&id=379d5749&scoped=true"
import script from "./AlertExpiration.vue?vue&type=script&lang=js"
export * from "./AlertExpiration.vue?vue&type=script&lang=js"

import "./AlertExpiration.vue?vue&type=style&index=0&id=379d5749&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-379d5749"

export default script